import { render } from "./Nep17TokensTable.vue?vue&type=template&id=63ec3905"
import script from "./Nep17TokensTable.vue?vue&type=script&lang=js"
export * from "./Nep17TokensTable.vue?vue&type=script&lang=js"

import "./Nep17TokensTable.vue?vue&type=style&index=0&id=63ec3905&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__